module.exports = __webpack_public_path__ + "static/media/023.595f2938.jpg";